import { NgModule } from '@angular/core';
import { AuthenticationGuard, canActivateChild } from './core/guards/authentication.guard';
import { Routes, RouterModule } from '@angular/router';
import { LayoutThemeComponent } from './layout/theme/theme.component';
import { EnterPartnerComponent } from './public/enter-partner/enter-partner.component';
import { RegisterPartnerComponent } from './public/register/register-partner.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { canActivateRedirectChild } from './core/guards/redirect.guard';
import { FlowComponent } from './contexts/snapshot/pages/flow/flow.component';
import { FlowResolver } from './contexts/snapshot/pages/flow/resolves/flow.resolver';
import { LoginGoogleComponent } from './public/login-google/login-google.component';
import { ConfigServiceComponent } from './public/config-service/config-service.component';

const routes: Routes = [
  { path: '', component: EnterPartnerComponent },
  { path: 'register', component: RegisterPartnerComponent },
  { path: 'config-service', component: ConfigServiceComponent },
  { path: 'register-info', component: RegisterPartnerComponent },
  { path: 'register-antifraud', component: RegisterPartnerComponent },
  { path: 'register-pix', component: RegisterPartnerComponent },
  { path: ':partner/login/google', component: LoginGoogleComponent },
  { path: ':partner', component: LayoutThemeComponent, canActivate: [canActivateChild] },
  {
    path: ':partner/:account', component: LayoutThemeComponent, canActivate: [canActivateChild], children: [
      { path: '', pathMatch: 'full', children: [], canActivate: [canActivateRedirectChild] },
      { path: 'dashboard', loadChildren: () => import('./contexts/dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'transactions', loadChildren: () => import('./contexts/transactions/transactions.module').then(m => m.TransactionsModule) },
      { path: 'messages', loadChildren: () => import('./contexts/messages/messages.module').then(m => m.MessagesModule) },
      { path: 'services', loadChildren: () => import('./contexts/services/services.module').then(m => m.ServicesModule) },
      { path: 'snapshot', loadChildren: () => import('./contexts/snapshot/snapshot.module').then(m => m.SnapshotModule), data: { animation: 'Flows' } },
      { path: 'settings', loadChildren: () => import('./contexts/settings/settings.module').then(m => m.SettingsModule) },
      { path: 'partners', loadChildren: () => import('./contexts/partners/partners.module').then(m => m.PartnersModule) },
      { path: 'merchants', loadChildren: () => import('./contexts/merchants/merchants.module').then(m => m.MerchantsModule), data: { reuseComponent: true } },
      { path: 'payment-links', loadChildren: () => import('./contexts/payment-links/payment-links.module').then(m => m.PaymentLinkModule) },
      { path: 'payout', loadChildren: () => import('./contexts/transfer/transfer.module').then(m => m.TransferModule) },
      { path: 'welcome', loadChildren: () => import('./contexts/welcome/welcome.module').then(m => m.WelcomeModule) },
      { path: 'financial-updates', loadChildren: () => import('./contexts/financial-updates/financial-updates.module').then(m => m.FinancialUpdatesModule) },
      { path: 'connections', loadChildren: () => import('./contexts/connections/connections.module').then(m => m.ConnectionsModule) },
      { path: 'authorizations', loadChildren: () => import('./contexts/authorizations/authorizations.module').then(m => m.AuthorizationsModule) },

    ],
  },
  {
    path: ':partner/:account/:merchant', component: LayoutThemeComponent, canActivate: [canActivateChild], children: [
      { path: '', redirectTo: 'payout', pathMatch: 'full', canMatch: [canActivateRedirectChild] },
      { path: 'transactions', loadChildren: () => import('./contexts-merchants/transactions/merchants-transactions.module').then(m => m.MerchantsTransactionsModule) },
      { path: 'settings', loadChildren: () => import('./contexts-merchants/settings/merchants-settings.module').then(m => m.MerchantSettingsModule) },
      { path: 'payout', loadChildren: () => import('./contexts-merchants/financial-transfer/financial-transfer.module').then(m => m.FinancialTransferModule) }
    ],
  },
  { path: ':partner/:account/snapshot/:snapshot_id/flow/:selector_test_id/:flow_id/:version/:order/:start/:end/:orders', component: FlowComponent, canActivate: [AuthenticationGuard], data: { animation: 'Flow' }, resolve: { flows: FlowResolver } },
  { path: ':partner/:account/snapshot/:snapshot_id/flow/:selector_test_id/:flow_id/:version/:order/:start/:end/:orders/manage', component: FlowComponent, canActivate: [AuthenticationGuard], data: { animation: 'Flow' }, resolve: { flows: FlowResolver } },

  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload',
      anchorScrolling: 'enabled',
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
